export async function fetchRetriable(
  url: string,
  init?: RequestInit & { retry?: number },
): Promise<Response> {
  let retried = 0;
  // The query string of signed links is noise (and a credential) in logs
  const displayUrl = url.split("?")[0];

  while (retried < (init?.retry ?? 3)) {
    let response: Response;
    try {
      response = await fetch(url, init);
    } catch {
      retried++;
      continue;
    }

    if (response.ok) return response;
    // Client errors (expired link, missing file…) won't be fixed by a retry
    if (response.status < 500)
      throw new Error(`Failed to fetch ${displayUrl}: ${response.status}`);
    retried++;
  }

  throw new Error(`Failed to fetch ${displayUrl} after ${retried} retries`);
}
